import React from 'react'
import { SmartDialog } from '../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import useAssetLiveData from './useAssetLiveData'
import AssetCardDialogs from './AssetCardDialogs'
import AssetDetailView from './AssetDetailView'

/**
 * AssetDetail — HU-05 composition root of the asset detail (mirrors `AssetCard.jsx`'s
 * pattern, RN8): wires `useAssetLiveData` (data) and the reused, unmodified
 * `AssetCardDialogs` (dialogs/actions, RN17/RN18) to the new `AssetDetailView`
 * (presentation, RN16). No new operative behaviour or permission is introduced (CA9).
 *
 * CA7/RN19 (S29): closing the detail is a plain state update in the parent screen —
 * no navigation happens, so the origin route/cell/filter are never left in the first
 * place. There is nothing to "restore" for this flow by construction.
 */
export default function AssetDetail ({ device, locations = [], mainImageInfo = {}, open, onClose, onItemClick = () => {}, onMainImageChange = () => {} }) {
  const { t_ } = useSmartTranslation()
  // Live-refresh only while actually open, mirroring the "on demand" pattern the
  // grid card already uses (see useAssetLiveData.js).
  const { deviceInfo, planificationLocations, loadStoragesByDevice, production, alarms } = useAssetLiveData(device ?? {}, 0, open, open, open)

  if (!device) return null

  return (
    <SmartDialog
      title={t_('Asset detail')}
      setOpen={open}
      close
      accept={false}
      cancel={false}
      closeCallback={onClose}
      renderComponent={
        <AssetCardDialogs
          device={device}
          locations={locations}
          planificationLocations={planificationLocations}
          loadStoragesByDevice={loadStoragesByDevice}
          onItemClick={onItemClick}
          onMainImageChange={onMainImageChange}
        >
          {(actions) => <AssetDetailView device={device} deviceInfo={deviceInfo} actions={actions} locations={locations} production={production} alarms={alarms} mainImageInfo={mainImageInfo} />}
        </AssetCardDialogs>
      }
    />
  )
}
